<template>
    <div class="url-form-container">
        <el-card class="form-card" shadow="hover">
            <template #header>
                <div class="card-header">
                    <el-icon>
                        <Link />
                    </el-icon>
                    <span>主页设置</span>
                </div>
            </template>

            <el-form ref="urlFormRef" :model="urlForm" :rules="formRules" label-width="120px" class="url-form">

                <!-- 直播房间号 -->
                <el-form-item label="你的昵称" prop="title">
                    <el-input v-model="urlForm.title" placeholder="你的昵称" @keyup.enter="submitForm" />
                </el-form-item>

                <!-- 主页URL -->
                <el-form-item label="宣传语" prop="content">
                    <el-input v-model="urlForm.content" placeholder="请输入宣传语" @keyup.enter="submitForm"
                        type="textarea" />
                </el-form-item>

                <!-- QQ -->
                <el-form-item label="站外反馈QQ" prop="content">
                    <el-input v-model="urlForm.QQ" placeholder="请输入QQ号" @keyup.enter="submitForm" />
                </el-form-item>

                <!-- 头像上传 -->
                <el-form-item label="头像">
                    <div class="avatar-uploader">
                        <el-upload class="avatar-uploader__trigger" :action="uploadUrl" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                            :http-request="fakeUpload">
                            <img v-if="urlForm.avatarUrl" :src="urlForm.avatarUrl"
                                class="avatar" />
                            <el-icon v-else>
                                <Plus />
                            </el-icon>
                        </el-upload>
                        <el-button v-if="urlForm.avatarUrl" type="text" size="small" @click="removeAvatar">
                            移除头像
                        </el-button>
                    </div>
                </el-form-item>

                <!-- 主页URL -->
                <el-form-item label="主题颜色" prop="color">
                    <el-color-picker v-model="urlForm.color" show-alpha />
                </el-form-item>

                <el-form-item label="气泡颜色" prop="backcolor">
                    <el-color-picker v-model="urlForm.backcolor" show-alpha />
                </el-form-item>

                <el-form-item label="底层颜色" prop="bottomcolor" v-show="false">
                    <el-color-picker v-model="urlForm.bottomcolor" show-alpha />
                </el-form-item>

                <el-form-item label="导航栏颜色" prop="Navigationcolor">
                    <el-color-picker v-model="urlForm.Navigationcolor" show-alpha />
                </el-form-item>

                <!-- 操作按钮 -->
                <el-form-item style="text-align: center; margin-top: 20px;">
                    <el-button type="primary" :loading="submitLoading" @click="submitForm">
                        提交
                    </el-button>
                    <el-button @click="resetForm">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import axios from 'axios';
import { ASSET_BASE } from '../../../util/assetBase';
import { Link, Plus } from '@element-plus/icons-vue';

// 表单引用
const urlFormRef = ref(null);

// 表单数据
const urlForm = reactive({
    title: '',
    content: '',
    color: 'rgba(255, 255, 255, 1)',
    backcolor: 'rgba(255, 255, 255, 1)',
    bottomcolor: 'rgba(255, 255, 255, 1)',
    Navigationcolor: 'rgba(255, 255, 255, 1)',
    avatarUrl: '',
    avatarFile: null,
    QQ: ''
});

// 表单验证规则
const formRules = reactive({
    title: [
        { required: true, message: '请输入你的昵称', trigger: 'blur' },
    ],
    content: [
        { required: true, message: '请输入你的宣传语', trigger: 'blur' },
    ],
});

// 上传URL (假URL，用于禁用自动上传)
const uploadUrl = 'https://example.com/upload';

// 提交状态
const submitLoading = ref(false);

// 假上传函数，阻止自动上传
const fakeUpload = (options) => {
    // 存储文件但不实际上传
    urlForm.avatarFile = options.file;

    // 创建预览URL - 修改这里
    const reader = new FileReader();
    reader.onload = (e) => {
        // 直接使用Data URL作为预览
        urlForm.avatarUrl = e.target.result;
    };
    reader.readAsDataURL(options.file);
};

// 处理头像上传成功
const handleAvatarSuccess = (res, file) => {
    urlForm.avatarUrl = URL.createObjectURL(file);
};

// 上传前校验
const beforeAvatarUpload = (file) => {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJPG) {
        ElMessage.error('上传头像图片只能是 JPG/PNG 格式!');
        return false;
    }

    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
        ElMessage.error('上传头像图片大小不能超过 10MB!');
        return false;
    }

    // 存储文件但不实际上传
    urlForm.avatarFile = file;

    // 创建预览URL
    const reader = new FileReader();
    reader.onload = (e) => {
        urlForm.avatarUrl = e.target.result;
    };
    reader.readAsDataURL(file);

    return false; // 阻止默认上传行为
};

// 移除头像
const removeAvatar = () => {
    urlForm.avatarUrl = '';
    urlForm.avatarFile = null;
};

// 提交表单
const submitForm = () => {
    urlFormRef.value.validate(async (valid) => {
        if (valid) {
            try {
                submitLoading.value = true;

                // 准备表单数据
                const formData = new FormData();
                formData.append('title', urlForm.title);
                formData.append('content', urlForm.content);
                formData.append('color', urlForm.color);
                formData.append('backcolor', urlForm.backcolor);
                formData.append('bottomcolor', urlForm.bottomcolor);
                formData.append('Navigationcolor', urlForm.Navigationcolor);
                formData.append('QQ', urlForm.QQ);


                // 如果有头像文件，添加到表单数据
                if (urlForm.avatarFile) {
                    formData.append('file', urlForm.avatarFile);
                } else {
                    formData.append('file', '');
                }

                // 发送POST请求
                const response = await axios.post('/adminapi/setting/updata', formData);

                // 处理响应
                if (response.data && response.data.code === 200) {
                    ElMessage.success('信息更新成功');
                    fetchFormData();

                    // 重置头像上传状态
                    urlForm.avatarFile = null;
                } else {
                    ElMessage.error(response.data.message || '提交失败，请重试');
                }
            } catch (error) {
                console.error('提交错误:', error);
                ElMessage.error('网络错误，请检查连接');
            } finally {
                submitLoading.value = false;
            }
        } else {
            ElMessage.error('请检查表单输入');
            return false;
        }
    });
};

// 重置表单
const resetForm = () => {
    urlFormRef.value.resetFields();
    removeAvatar();
};

// 获取表单数据
const fetchFormData = async () => {
    try {
        const response = await axios.get('/adminapi/setting/list');

        // 更新表单数据
        urlForm.title = response.data.results[0]?.title || '';
        urlForm.content = response.data.results[0]?.content || '';
        urlForm.color = response.data.results[0]?.color || 'rgba(255, 255, 255, 1)';
        urlForm.backcolor = response.data.results[0]?.backcolor || 'rgba(255, 255, 255, 1)';
        urlForm.bottomcolor = response.data.results[0]?.bottomcolor || 'rgba(255, 255, 255, 1)';
        urlForm.Navigationcolor = response.data.results[0]?.Navigationcolor || 'rgba(255, 255, 255, 1)';
        urlForm.avatarUrl = response.data.results[0]?.avater ? ASSET_BASE + response.data.results[0].avater : '';
        urlForm.QQ = response.data.results[0]?.QQ || '';

        // 重置文件对象
        urlForm.avatarFile = null;
    } catch (error) {
        console.error('加载错误:', error);
        ElMessage.error('网络错误，请检查连接');
    }
};

onMounted(() => {
    fetchFormData();
});
</script>

<style lang="scss" scoped>
.url-form-container {
    padding: 30px;
    max-width: 800px;
    margin: 0 auto;

    .form-card {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        color: #303133;
        font-size: 18px;
        font-weight: 500;

        .el-icon {
            margin-right: 10px;
            color: #409eff;
        }
    }

    .url-form {
        .el-form-item {
            margin-bottom: 20px;
        }

        .el-input {
            &::v-deep {
                .el-input__inner {
                    border-radius: 4px;
                    transition: border-color 0.3s, box-shadow 0.3s;
                }

                &:focus-within .el-input__inner {
                    border-color: #409eff;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }
            }
        }

        .avatar-uploader {
            .avatar-uploader__trigger {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 120px;
                height: 120px;
                border: 1px dashed #d9d9d9;
                border-radius: 50%;
                cursor: pointer;
                transition: border-color 0.3s;

                &:hover {
                    border-color: #409eff;
                }

                .el-icon {
                    font-size: 28px;
                    color: #8c939d;
                }
            }

            .avatar {
                width: 120px;
                height: 120px;
                border-radius: 50%;
                object-fit: cover;
            }
        }
    }
}
</style>